import { Controller } from '@hotwired/stimulus'

export default class RepLeadsController extends Controller {
  static targets = ['table']

  static values = {
    url: String,
    repId: String,
    leadPathTemplate: String
  }

  connect() {
    this.element.style.display = 'block'
    this.table = this.initDataTable()
  }

  disconnect() {
    if (this.table) {
      this.table.destroy()
      this.table = null
    }
  }

  close() {
    this.element.remove()
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  initDataTable() {
    const $ = window.jQuery
    if (!$ || !$.fn || !$.fn.DataTable) {
      return null
    }

    if ($.fn.DataTable.isDataTable(this.tableTarget)) {
      $(this.tableTarget).DataTable().destroy()
    }

    return $(this.tableTarget).DataTable({
      processing: true,
      serverSide: true,
      searchDelay: 1000,
      order: [[3, 'desc']],
      dom: `
              <"row mb-3"
                  <"col-sm-6"f>
              >
              <"row"
                  <"col-sm-12"tr>
              >
              <"row mt-3"
                  <"col-sm-4 pt-2 pl-1"l>
                  <"col-sm-4 pt-3 text-center"i>
                  <"col-sm-4 d-flex justify-content-end"p>
              >
          `,
      ajax: {
        url: this.urlValue,
        type: 'GET',
        data: (d) => {
          d.page_number = Math.floor(d.start / d.length) + 1
          d.id = this.repIdValue
        },
        dataSrc: 'data'
      },
      columns: [
        { data: 'first_name', title: 'First Name' },
        { data: 'last_name', title: 'Last Name' },
        { data: 'company', title: 'Company' },
        { data: 'assigned_on', title: 'Assigned On' },
        { data: 'city', title: 'City' },
        { data: 'postal_code', title: 'Postal Code' },
        { data: 'state_code', title: 'State' },
        { data: 'country_code', title: 'Country' }
      ],
      createdRow: (row, data) => {
        const href = this.leadPathTemplateValue.replace(':id', data.lead_id)
        $(row).attr('data-href', href)
        $(row).css('cursor', 'pointer')

        $(row).on('click', () => {
          this.close()
          window.location.href = href
        })
      }
    })
  }
}
